<template>

    <div class="field">
        <label class="label">{{ props.etichetta }}</label>
        <button class="button" @click="bAzione">
            <span class="icon"  v-if="valoreCondizionato">
                <i class="fas fa-check" ></i>
            </span>                    
            <span class="icon"  v-if="!valoreCondizionato">
                <i class=""></i>
            </span>                    
        </button>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, ref } from "vue";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        valore: {
            type: Boolean,
            default: false
        },
        identificativo: {
            type: String,
            default: ''
        },
        etichetta: {
            type: String,
            default: ''
        }
    });
    const emit = defineEmits(['valoreCambiato']);

    // VARIABILI DEL COMPONENTE
    const valoreCondizionato = ref(props.valore);

    // SETUP DEL COMPONENTE
    // condizionaValore();

    // FUNZIONI DEL COMPONENTE
    function bAzione() {
        valoreCondizionato.value = valoreCondizionato.value? false : true;
        emit('valoreCambiato', valoreCondizionato.value, props.identificativo);
    }

</script>